import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { isConflictError, showApiErrorToast } from '@/utils/errors';
import { createUser } from '../api/users.api';
import { userQueryKeys } from '../api/users.api';
import type { CreateUserPayload } from '../types/user.types';

export function useCreateUser(onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateUserPayload) => createUser(payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: userQueryKeys.all() });
      toast.success('User created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      if (isConflictError(error)) return;
      showApiErrorToast(error, 'Failed to create user');
    },
  });
}
